import { Heat } from '@vote4dance/judging-schema';
import { RoundId } from '@vote4dance/judging-types';
import { StreamSource } from "../hooks/streams";

export type HeatItem = Heat
& {
    heat_judges_done: boolean,
    heat_team_count: number,
}


export function HeatSource(round_id: RoundId) {
    return new StreamSource<HeatItem[]>(`/heats/${round_id}`);
}
